import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';
import { CreateFormSubmissionDto, CreateFormSubmissionResponse } from './types';

/**
 * Create a new form submission
 */
export async function createFormSubmission(
  data: CreateFormSubmissionDto,
  shareToken: string | undefined
): Promise<{ success: boolean; data?: CreateFormSubmissionResponse }> {
  try {
    const res = await fetcher(BASE_URL, {
      method: 'POST',
      body: data,
      shareToken,
    });

    if (!res.ok) {
      console.error('Failed to create form submission:', await res.text());
      return { success: false };
    }

    const responseData = (await res.json()) as CreateFormSubmissionResponse;
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error('Error creating form submission:', err);
    return { success: false };
  }
}

